import ordersBatchSaga from '~/sagas/orders-batch/orders-batch.saga';

export default ordersBatchSaga;
